export enum EFasi{
    F1_LEAD_ACQUISITO = 1,
    F2_NUTRING = 2,
    F3_RICHIESTA_CONSULENZA = 3,
    F4_CONSULENZA_PRENOTATA = 4,
    F5_PROPOSTA_EFFETTUATA = 5
}